import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {AuthInterceptorService} from '../interceptor/auth-interceptor.service';
import { CookieCiencuadras } from '../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { CognitoIdentityPoolService } from '../cognito-identity-pool/cognito-identity-pool.service';

@Injectable({
  providedIn: 'root',
})
export class LambdaSecurityService implements HttpInterceptor {
  private isLogged = false;

  constructor(
    private cookieService: CookieCiencuadras,
    private identityService: CognitoIdentityPoolService,
    private userService: AuthInterceptorService,
  ) {
    // Verificar si el usuario está logueado
    this.isLogged = !!this.cookieService.getCookie(
      CookieCiencuadras.COOKIE_ID_USER,
    );
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // Determina cuál servicio usar en función de si el usuario está logueado o no
    if (!this.isLogged) {
      // Si no está logueado, usa cognito identity para obtener el token
      return this.identityService.intercept(req, next);
    } else {
      // Si está logueado, usa cognito user para obtener el token
      return this.userService.intercept(req, next);
    }
  }
}
